import {IApiService} from "@murphy-frontend/common/interfaces/IApiService"
import {AxiosResponse} from "axios"
import {
	CustomerBlockDto,
	CustomerRequirementLevelDto,
	RequirementBlockDto,
	RequirementCategoryDto,
	UpdateBlockStatusesRequest,
	UpdateCustomerGoalLevelRequest,
	UpdateBlockActionPointRequest,
	CreateBlockActionPointRequest,
	UpdateBlockActionPointResponseRequest,
	DeleteBlockActionPointRequest,
	CreateBlockNoteRequest,
	DeleteBlockNoteRequest,
	UpdateBlockNoteRequest,
	RequirementDashboard,
	CustomerCapacityReport,
    CustomerPoints,
    CustomerRoadmapResponse
} from "./models"

export class RequirementApi {
	constructor(private apiService: IApiService) {}

	getRequirementBlocks = async (): Promise<RequirementBlockDto[]> => {
		const url = "api/RequirementBlock"
		const {data} = await this.apiService.callApi(url, "GET")
		return data
	}

	getRequirementBlocksById = async (id: number): Promise<RequirementBlockDto> => {
		const url = `api/RequirementBlock/${id}`
		const {data} = await this.apiService.callApi(url, "GET")
		return data
	}

	getCustomerRequirementBlocks = async (customerId: string): Promise<CustomerBlockDto[]> => {
		const url = `api/Customer/${customerId}/RequirementBlock`
		const {data} = await this.apiService.callApi(url, "GET")
		return data
	}
	getCustomerRequirementDashboard = async (customerId: string): Promise<RequirementDashboard> => {
		const url = `api/Customer/${customerId}/RequirementDashboard`
		const {data} = await this.apiService.callApi(url, "GET")
		return data
	}
	getCustomerParentRequirementDashboard = async (customerId: string): Promise<CustomerPoints[]> => {
		const url = `api/Customer/${customerId}/RequirementDashboard/parent`
		const {data} = await this.apiService.callApi(url, "GET")
		return data
	}
	getCustomerCapacityReport = async (customerId: string): Promise<CustomerCapacityReport> => {
		const url = `api/Customer/${customerId}/CapacityReport`;
		const { data } = await this.apiService.callApi(url, "GET");
		return data
	}
	updateCustomerRequirementBlockStatus = (request: UpdateBlockStatusesRequest): Promise<AxiosResponse> => {
		const url = `api/Customer/${request.CustomerId}/RequirementBlock`
		return this.apiService.callApi(url, "POST", request)
	}

	getRequirementLevels = async (customerId: string): Promise<CustomerRequirementLevelDto[]> => {
		const url = `api/Customer/${customerId}/RequirementLevel`
		const {data} = await this.apiService.callApi(url, "GET")
		return data
	}

	updateCustomerGoalLevel = (request: UpdateCustomerGoalLevelRequest): Promise<AxiosResponse> => {
		const url = `api/Customer/${request.CustomerId}/RequirementLevel`
		return this.apiService.callApi(url, "POST", request)
	}

	getRequirementCategories = async (): Promise<RequirementCategoryDto[]> => {
		const url = "api/RequirementCategory"
		const {data} = await this.apiService.callApi(url, "GET")
		return data
	}

	deleteCustomerRequirementBlockActionPoint = (request: DeleteBlockActionPointRequest): Promise<AxiosResponse> => {
		const url = `api/Requirement/${request.CustomerId}/RequirementBlockActionPoint/${request.RequirementBlockActionPointId}`
		return this.apiService.callApi(url, "DELETE")
	}

	updateCustomerRequirementBlockActionPoint = (request: UpdateBlockActionPointRequest): Promise<AxiosResponse> => {
		const url = `api/Requirement/${request.CustomerId}/RequirementBlockActionPoint/${request.RequirementBlockActionPointId}`
		return this.apiService.callApi(url, "PUT", {Description: request.Description})
	}

	createCustomerRequirementBlockActionPoint = (request: CreateBlockActionPointRequest): Promise<AxiosResponse> => {
		const url = `api/Requirement/${request.CustomerId}/RequirementBlockActionPoint/${request.RequirementBlockId}`
		return this.apiService.callApi(url, "POST", {Description: request.Description})
	}

	updateRequirementBlockActionPointResponse = (request: UpdateBlockActionPointResponseRequest): Promise<AxiosResponse> => {
		const url = `api/Requirement/${request.CustomerId}/RequirementBlockActionPointResponse/${request.RequirementBlockActionPointId}`
		return this.apiService.callApi(url, "POST", {Status: request.Status})
	}

	createCustomerRequirementBlockNote = (request: CreateBlockNoteRequest): Promise<AxiosResponse> => {
		const url = `api/Requirement/${request.CustomerId}/RequirementBlockNote/${request.RequirementBlockId}`
		return this.apiService.callApi(url, "POST", {Note: request.Note})
	}

	updateCustomerRequirementBlockNote = (request: UpdateBlockNoteRequest): Promise<AxiosResponse> => {
		const url = `api/Requirement/${request.CustomerId}/RequirementBlockNote/${request.RequirementBlockNoteId}`
		return this.apiService.callApi(url, "PUT", {Note: request.Note})
	}

	deleteCustomerRequirementBlockNote = (request: DeleteBlockNoteRequest): Promise<AxiosResponse> => {
		const url = `api/Requirement/${request.CustomerId}/RequirementBlockNote/${request.RequirementBlockNoteId}`
		return this.apiService.callApi(url, "DELETE")
	}

	getRoadmapItems = async (customerId: string): Promise<CustomerRoadmapResponse> => {
		const url = `api/Requirement/${customerId}/Roadmap`;
		const { data } = await this.apiService.callApi(url, "GET");
		return data;
	}

	updateRoadmapItem = async (
		customerId: string,
		itemId: number,
		update: { DueDate?: string; ResponsibleUserOrContact?: string }
	): Promise<void> => {
		const url = `api/Requirement/${customerId}/RoadmapItem/${itemId}`;
		await this.apiService.callApi(url, "PUT", update);
	};
}